import React from 'react';
import beTwMerge from '@/utils/beTwMerge';
import DropdownButton from '../homepage/DropdownButton';

interface MissionNavTopProps {
  links: MissionNavItemProps[];
  hasBottomLine?: boolean;
}

interface MissionNavItemProps {
  label: string;
  href?: string;
  isActive?: boolean;
}

function MissionNavItem({ label, href, isActive = false }: MissionNavItemProps) {
  return (
    <div className={beTwMerge('tw-relative tw-inline-flex tw-flex-col tw-text-center tw-justify-center')}>
      <a href={!isActive ? href : undefined} className="hover:tw-no-underline">
        <h4 className="tw-mt-1 tw-mb-1 tw-text-color-white hover:tw-text-color-light-green-light">{label}</h4>
      </a>
      {isActive && <span className="tw-w-full tw-h-[3px] tw-bg-color-light-green-light" />}
    </div>
  );
}

export default function MissionNavTop({ links, hasBottomLine = false }: MissionNavTopProps): JSX.Element {
  const activeLink = links.find(obj => obj.isActive === true);
  const newArrayWithoutActive = links.filter(obj => obj !== activeLink);
  const bottomLineClass = hasBottomLine ? 'borderBottomNav' : '';

  return (
    <div className={beTwMerge('tw-w-full tw-px-0 lg:tw-px-[32px] tw-bg-color-dark-green')}>
      <div
        className={beTwMerge(
          'tw-hidden lg:tw-flex tw-py-0 tw-relative tw-items-start tw-justify-between md:tw-py-[16px] lg:tw-py-[16px] lg:tw-max-w-[910px] tw-mx-auto'
        )}
      >
        {links?.map(link => (
          <MissionNavItem key={link.label} label={link.label} href={link.href} isActive={link.isActive} />
        ))}
      </div>

      <div className={beTwMerge('tw-flex', bottomLineClass)}>
        <DropdownButton
          className="lg:tw-hidden tw-w-full md:tw-w-full tw-max-w-full [&>button]:tw-w-full [&>button]:tw-max-w-full [&>button>span]:tw-text-left [&>button]:tw-indent-0 [&>button]:tw-text-[14px] [&>button]:tw-font-medium [&>button]:md:tw-text-[16px] [&>button]:lg:tw-text-[18px] [&_a]:tw-text-[14px] [&_a]:tw-font-medium [&_a]:md:tw-text-[16px] [&_a]:lg:tw-text-[18px]"
          label={activeLink?.label || ''}
          options={newArrayWithoutActive}
        />
      </div>
    </div>
  );
}
